__turbopack_context__.v({
  "className": "lustria_ae1aedde-module__69DE9a__className",
  "variable": "lustria_ae1aedde-module__69DE9a__variable",
});
